<template lang="pug">
  div
    .text-center.mt-4
      stamp-collected-top-icon(v-if="loyaltySystem === 'stamps'" :name="profile.name" :stampCount="profile.collected")
      point-collected-top-icon(v-else :name="profile.name" :pointCount="collectedData.collect_value")
    simple-profile.mb-6(:name="profile.name" :phone="profile.phone")
    v-row(no-gutters)
      v-col.mr-2
        v-card.pa-4.round-xl(outlined)
          v-icon.mb-2(color="neutral700") $yzi-link-01
          .text-sm.text-left.mb-2 Share link to customer’s loyalty profile. Link is unique.
          .d-flex
            v-spacer
            .text-sm.underline.font-semibold.cursor-pointer.hover-bg(@click="") Copy link
        div(ref="copy")
      v-col.ml-2
        v-card.pa-4.round-xl(outlined style="height: 100%")
          v-icon.mb-2(color="success500") $yzi-gift-02
          .text-sm.text-left.mb-2 {{ availableRewardCount }} {{ 'reward' | pluralize({ count:availableRewardCount }) }} available to redeem
          .d-flex.mt-6
            v-spacer
            .text-sm.underline.font-semibold.cursor-pointer.hover-bg(v-if="availableRewardCount > 0" @click="$emit('redeem')") Redeem
    .text-center.mt-8
      v-btn.button-md.white--text.mb-4(color="neutral700" depressed @click="")
        v-icon.mr-2 $yzi-message-text-square-02
        div Send review request
      v-btn.button-md.underline(color="neutral700" text @click="handleBackToCollectPage") Back to collect page
</template>

<script>

import StampCollectedTopIcon from "@/components/marketing/merchantapp/stamps/StampCollectedTopIcon.vue";
import PointCollectedTopIcon from "@/components/marketing/merchantapp/points/PointCollectedTopIcon.vue";
import SimpleProfile from "@/components/marketing/merchantapp/SimpleProfile.vue";

export default {
  components: {
    SimpleProfile,
    PointCollectedTopIcon,
    StampCollectedTopIcon
  },
  props: {
    loyaltySystem: {
      type: String,
      required: true
    },
    collectedData: {
      type: Object,
      required: true
    }
  },
  computed: {
    availableRewardCount() {
      return this.profile?.available_rewards?.length || 0
    },
    profile() {
      return this.collectedData?.member
    }
  },
  methods: {
    handleBackToCollectPage() {
      this.$emit('backToCollectPage')
    }
  },
}
</script>

<style scoped>
</style>
